import { render, staticRenderFns } from "./Track.vue?vue&type=template&id=38a308b5&"
import script from "./Track.vue?vue&type=script&lang=js&"
export * from "./Track.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports